// The public recipe page (/r/<slug>) 404s draft, archived and secret recipes unless the request
// carries a valid admin ID token. Firebase Hosting only forwards the `__session` cookie to
// functions, so the CRM keeps it fresh and its "open public page" links keep working for admins.
const COOKIE_NAME = "__session";
const COOKIE_PATH = "/r";
const ID_TOKEN_LIFETIME_SECONDS = 3600;

export function buildPreviewCookie(idToken) {
  const attrs = `Path=${COOKIE_PATH}; Secure; SameSite=Lax`;
  if (!idToken) return `${COOKIE_NAME}=; ${attrs}; Max-Age=0`;
  return `${COOKIE_NAME}=${idToken}; ${attrs}; Max-Age=${ID_TOKEN_LIFETIME_SECONDS}`;
}

export async function syncPreviewCookie(user) {
  try {
    document.cookie = buildPreviewCookie(user ? await user.getIdToken() : null);
  } catch (err) {
    console.warn("Could not sync recipe preview cookie:", err);
  }
}
